export default __webpack_public_path__ + "static/media/home.380b0b7b.png";